/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import { bool, func } from "prop-types";
import { actions as comexActions } from "reducers/comex";
import { Col, Row } from "react-bootstrap";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import Button from "pages/_components/Button";
import ClearanceForm from "./components/ClearanceForm";

// eslint-disable-next-line arrow-body-style
const Online = ({ isDesktop, handleSubmit }) => {
    const dispatch = useDispatch();

    const { comexTransfer = {}, comexId = null } = useSelector((state) => state.comex);

    const comexTransferRequest = {
        ...comexTransfer,
        step: "stepCLEARANCE",
    };
    const { clearancesData = {} } = comexTransferRequest;
    const { clearances = [] } = clearancesData;

    const [items, setItems] = useState([{}]);
    const [itemCompleted, setItemCompleted] = useState([]);
    const [updateItems, setUpdateItems] = useState(false);

    useEffect(() => {
        dispatch(comexActions.getComexSelectors());
    }, []);

    const getValidItems = () => items.filter((elem) => Object.keys(elem).length !== 0 && elem.deleted === undefined);

    const onSubmit = () => {
        const data = {
            type: "online",
            clearances: getValidItems(items),
        };
        handleSubmit(data);
    };

    useEffect(() => {
        if (clearances && clearances.length > 0) {
            setItems(clearances);
            setUpdateItems(!updateItems);
            onSubmit();
        }
    }, [clearances]);

    const isDeleted = (obj) => Object.keys(obj).length !== 0 && obj.deleted !== undefined;

    const numberOfEditableItems = () => items.filter((e) => !isDeleted(e)).length;

    const getDisableContinue = () => {
        const itemsValid = items.filter((_elem, idx) => itemCompleted[idx] === true);
        return itemsValid.length === 0 || itemsValid.length !== numberOfEditableItems();
    };

    const updateFlagItemsCompleted = (value, index) => {
        const auxIsCompleted = itemCompleted;
        auxIsCompleted[index] = value;
        setItemCompleted(auxIsCompleted);
    };

    const handleAddItem = () => {
        const aux = items;
        aux.push({});
        setItems(aux);
        setUpdateItems(!updateItems);
    };

    const handleDeleteItem = (index) => {
        const aux = items;
        aux[index] = { deleted: true };
        setItems(aux);
        setUpdateItems(!updateItems);

        updateFlagItemsCompleted(false, index);

        onSubmit();
    };

    const handleUpdateItem = (item, index, isCompleted) => {
        const aux = items;
        if (aux.length === 0) {
            aux.push(item);
        } else {
            aux[index] = item;
        }
        setItems(aux);

        updateFlagItemsCompleted(isCompleted, index);

        setUpdateItems(!updateItems);
        onSubmit();
    };

    const handleContinue = () => {
        const data = {
            type: "online",
            clearances: getValidItems(items),
        };
        const _comexRequest = {
            ...comexTransferRequest,
            clearancesData: data,
            comexId,
            isContinue: true,
        };

        dispatch(comexActions.setComexTransfer(_comexRequest));
        dispatch(comexActions.createComexTransfer(_comexRequest));
        dispatch(push("/comex/goods/paymentdata"));
    };

    return (
        <div className="clearance-online-container">
            <div className="box info">
                <CustomData
                    icon="information_fill.svg"
                    titleText="comex.clearance.online.info"
                    titleTextType="I18N"
                    keepSpaceIfNoValue={false}
                />
            </div>
            <div className="comex-clearance-online-title">
                <h2>
                    <CustomText text="comex.clearance.online.title" textType="I18N" />
                </h2>
            </div>
            <div>
                <div className="comex-clearance-table">
                    {items.map((item, index) => {
                        if (!isDeleted(item)) {
                            return (
                                // eslint-disable-next-line react/no-array-index-key
                                <Row className="comex-clearance-container" align="center" key={index}>
                                    <ClearanceForm
                                        isDesktop={isDesktop}
                                        handleAddItem={(e) => handleAddItem(e)}
                                        handleDeleteItem={() => handleDeleteItem(index)}
                                        handleUpdateItem={(clearance, idx, isCompleted) =>
                                            handleUpdateItem(clearance, idx, isCompleted)
                                        }
                                        index={index}
                                        clearenceData={item}
                                        numberOfClearances={getValidItems().length}
                                        updateItemsCompleted={(value) => updateFlagItemsCompleted(value, index)}
                                        numberOfEditableItems={numberOfEditableItems()}
                                    />
                                </Row>
                            );
                        }
                        // eslint-disable-next-line react/no-array-index-key
                        return <div key={index} />;
                    })}
                </div>
                <Row className="form-actions">
                    <Col xs={10} xsOffset={1} md={4} mdOffset={4}>
                        <Button
                            className="btn-primary"
                            label="global.continue"
                            onClick={() => handleContinue()}
                            disabled={getDisableContinue()}
                        />
                    </Col>
                </Row>
            </div>
        </div>
    );
};

Online.propTypes = {
    isDesktop: bool.isRequired,
    handleSubmit: func.isRequired,
};

export default Online;
